import { Text } from "@otrium/atoms";
import { SeparatorMessageWrapper } from "./SeparatorMessage.styled";

const SeperatorMessage = ({
  children,
  ...rest
}: {
  children: any;
}): JSX.Element => {
  return (
    <SeparatorMessageWrapper {...rest}>
      <Text color={"tone.anthraciteLight"} fontSize={0} as="span">
        {children}
      </Text>
    </SeparatorMessageWrapper>
  );
};

export default SeperatorMessage;
